import { Component, Input, OnInit } from '@angular/core';
import { AppService } from 'app/main/services/app.service';

@Component({
	selector: 'snackbar',
	templateUrl: 'snackbar.component.html',
	styleUrls: ['snackbar.component.scss']
})
export class SnackbarComponent implements OnInit {
	constructor(public appService: AppService) { }

	ngOnInit(): void {}
}
